import { render, staticRenderFns } from "./VehicleDetailsActionsButton.vue?vue&type=template&id=06267d10&"
import script from "./VehicleDetailsActionsButton.vue?vue&type=script&lang=js&"
export * from "./VehicleDetailsActionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports